// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"367a7f20","184":"9e34e633","195":"5d15e842","326":"0c1e196b","395":"c58b469d","398":"4f942654","615":"06442554","625":"9697ab6d","639":"68d519b2","661":"5a67eaa8","673":"b97303ae","684":"53ca6cb0","699":"397c08c9","708":"6b6eafbb","720":"43486245","816":"1352a924"}[chunkId] + ".chunk.js";
};